// production vars
const config = {
  firebaseApiKey: "AIzaSyBOslfxdqhonB_0X12Few82gxS5LXNqL9E",
  firebaseProjectId: "screen6-portal",
  firebaseMessagingSenderId: "531033358627",
  buckets: {
    eu: "gs://screen6-amp-prod-eu",
    us: "gs://screen6-amp-prod-us",
  }
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config/production.js